import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import Loading from '../loading';

const Districts = ({ districts }) => {

    const nav = useNavigate();

    const handleNav = d => {
        nav(`/repeater/${d.district}`);
    }

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const [repeaterCollapse, setRepeaterCollapse] = useState(isMobile);

    // Only the mobile layout supports collapsing — if the viewport grows
    // past the breakpoint, always show the full list again.
    useEffect(() => {
        if (!isMobile) {
            setRepeaterCollapse(false);
        }
    }, [isMobile]);

    if (!districts[0]) {
        return <Loading />;
    }

    const sorted = [...districts].sort((a, b) => (parseInt(a.district) > parseInt(b.district) ? 1 : -1));

    return (
        <Card sx={{ p: 2 }}>
            <Stack direction="row" alignItems="center" justifyContent="center" sx={{ position: 'relative', mb: repeaterCollapse ? 0 : 2 }}>
                <Typography variant="h5">Repeaters</Typography>
                {isMobile && (
                    <IconButton
                        onClick={() => setRepeaterCollapse(!repeaterCollapse)}
                        size="small"
                        sx={{ position: 'absolute', right: 0 }}
                    >
                        {repeaterCollapse ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                    </IconButton>
                )}
            </Stack>
            {!repeaterCollapse && (
                <Stack spacing={1.5}>
                    {sorted.map(d => (
                        <Card key={d._id} variant="outlined" sx={{ cursor: 'pointer' }}>
                            <CardActionArea onClick={() => handleNav(d)}>
                                <CardContent sx={{ textAlign: 'center' }}>
                                    <Typography variant="subtitle1">{d.district} MHz</Typography>
                                    {d.modes[0] && (
                                        <Stack direction="row" spacing={0.5} justifyContent="center" flexWrap="wrap" useFlexGap sx={{ mt: 1 }}>
                                            {d.modes.map((m, i) => (
                                                <Chip key={i} label={m.value} size="small" />
                                            ))}
                                        </Stack>
                                    )}
                                    <Chip
                                        label={d.status === "Off Air" ? "Off Air" : "On Air"}
                                        color={d.status === "Off Air" ? "error" : "success"}
                                        size="small"
                                        sx={{ mt: 1 }}
                                    />
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    ))}
                </Stack>
            )}
        </Card>
    );
};

export default Districts
